import React from 'react'
import "../Assets/styles/video.css"

const Video = () => {
  return (
    <>
        <div className="video-section">
        </div>
    </>
  )
}

export default Video